<script>
import BaseResource from '../resources'
import ImageResource from '../resources/image'

export default {
    name: 'RelatedImage',
    components: {

    },
    computed: {
        
    },
    props: {
        for: {
            type: BaseResource,
            required: true
        },
        field: {
            type: String,
            default: 'image'
        },
        height: [Number, String],
        width: [Number, String],
        fluid: Boolean,
        fluidGrow: Boolean,
        block: Boolean,
        left: Boolean,
        right: Boolean,
        center: Boolean,
        rounded: [String, Boolean],
        sizes: [Array, String],
        thumbnail: Boolean

    },
    data() {
        return {
            loading: true,
            source: ''
        }
    },
    methods: {
        async load() {
            this.loading = true
            this.source = await this.for.resolveAttribute(`${this.field}.source`)
            this.loading = false
        }
    },
    async mounted() {
        this.load()
    }
}
</script>

<template>
    <b-img :src="source" v-bind="$props" />
</template>

<style lang="scss">
</style>
